import { Card, CardContent } from '@/components/ui/card';
import { sponsorBenefits } from '@/data/sponsor/benefits';

const WhySeniorThriveSection = () => {
  return (
    <div className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Why Advisors Choose SeniorThrive
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            SeniorThrive becomes part of your advisory model, helping you stay relevant as clients and families navigate aging at home.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {sponsorBenefits.map((benefit, index) => (
            <Card key={index} className="border-border/50 hover:border-primary/20 transition-colors">
              <CardContent className="p-8 text-center">
                <h4 className="text-xl font-bold text-foreground mb-4">
                  {benefit.title}
                </h4>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhySeniorThriveSection;
